const ActionButton: React.FC<ActionButtonProps> = ({
    children,
    type = 'submit',
    color = 'green',
    icon,
    isPosting = false,
    disabled = false,
    inline = false,
    onClick = () => {},
}) => (
    <button
        className={`button ${color}`}
        type={type}
        disabled={isPosting || disabled}
        onClick={onClick}
        style={inline ? { display: 'inline-flex', margin: '0 10px' } : {}}
    >
        {icon && !isPosting && <i className={`icon far fa-fw fa-${icon}`}></i>}
        {isPosting && <i className="icon far fa-fw fa-spinner fa-spin"></i>}
        <span className="text">{children}</span>
    </button>
);

interface ActionButtonProps {
    type?: 'submit' | 'button' | 'reset';
    color?: string;
    icon?: string;
    isPosting?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    disabled?: boolean;
    inline?: boolean;
}

export default ActionButton;
